import sideImage from "../images/afro-solar/solar-microgrids/side-image.webp";

const SolarMicroGrids = () => {
  return (
    <div className="container-fluid pt-7 pb-7" id="solar-micro-grid">
      <div className="me-13 ms-13">
        <div className="row">
          <div className="col-12 col-md-12 col-lg-6 my-auto">
            <div className="row">
              <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start mb-5 mb-md-0">
                <div className="bg-primary rounded-circle d-flex justify-content-center align-items-center text-center text-white p-3 fs-16 solar-microgrid-image-1">
                  A typical solar microgrid can range from 1 kW to several
                  megawatts.
                </div>
              </div>
              <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start mb-5 mb-md-0">
                <div className="bg-primary rounded-circle d-flex justify-content-center align-items-center text-center text-white p-3 fs-16 solar-microgrid-image-2">
                  For a village of 100 homes, a 4 kW microgrid is sufficient.​
                </div>
              </div>
              <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start mb-5 mb-md-0">
                <div className="bg-primary rounded-circle d-flex justify-content-center align-items-center text-center text-white p-3 fs-16 solar-microgrid-image-3">
                  A 4 kW plant generate electricity worth Rs.33,000 per year.​
                </div>
              </div>
            </div>

            <h2 className="fs-56 lh-64 gilroy-bold mt-5">
              SOLAR <span className="text-orange-ryb">MICROGRIDS</span>
            </h2>
            <h4 className="fs-22 pb-5">
              Powering remote locations for a happier tomorrow
            </h4>
            <p className="fs-16 my-4 lh-30 text-align-justify">
              AFRO Solar provides custom solutions to power remote regions that
              might be cut off from regular electric grids. Installing
              microgrids in such areas ensures access to green power.
            </p>
            <p className="fs-16 my-4 lh-30 text-align-justify">
              AFRO Solar takes pride in working with the Government. We welcome
              range of benchmark projects for organizations to design and deploy
              solar power solutions for specific needs. AFRO Solar aims through
              Government & NGO initiatives for Thousands of villages to have
              power for at least 6 hours a day.
            </p>
          </div>
          <div className="col-12 col-md-12 col-lg-6">
            <img
              src={sideImage}
              alt="solar micro grids"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolarMicroGrids;
